import css from 'styled-jsx/css';

const styles = css.global`.select-field {
  position: relative;
}

.select-field .select-element {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  border: none;
  z-index: 2;
  box-shadow: 0px 2px 8px -2px #2222221f;
  border-radius: 6px;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  height: auto;
  padding: 0 16px 8px;

  max-height: calc(4 * 45px);
  overflow: auto;
  display: none;
  z-index: 10;
}

.select-field .select-element.active {
  display: flex;
}

.select-field .option-element {
  box-sizing: border-box;
  padding: 8px 0;
  border-bottom: 1px solid #cccccc;
  cursor: pointer;
  display: flex;
}

.select-field .option-element:last-of-type {
  border-bottom: none !important;
}

.select-field .option-element p {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  vertical-align: middle;
  margin: 0;
  padding: 0;
}

.select-field.single-line .option-element {
  height: 45px;
  min-height: unset;
  display: block;
}

.select-field.single-line .option-element p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.select-field .option-element.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.select-field.show-clear .text-field__end-adornment {
  pointer-events: all !important;
  z-index: 3;
  cursor: pointer;
}
`;

export default styles;